module.exports = "/assets/data/6573ba97d0776b540d74ad549dc2c73b-NR27.data.json";